export const NEWBUILDING_OFFERS_CAROUSEL_OPTIONS = {
  spaceBetween: 16,
  slidesPerView: 5,
  slidesPerGroup: 5,
  allowTouchMove: false,
  className: 'newbuilding-offers-carousel',
  testId: 'NewbuildingOffersCarousel',
};

export const MAX_OFFERS_BEFORE_CAROUSEL = 4;

export const BANNER_POSITION = 1;

export const ACTION_AFTER_VIEWED_TIMEOUT = 1000;
